// Public user-feedback board (userinput.app). Single source of truth for the
// feedback link used by the user menu, FAQ, and the floating feedback button.
export const FEEDBACK_URL =
  "https://userinput.app/s/did:plc:3zzkrrjtsmo7nnwnvhex3auj/3mo3baeffwk2w";
